export const LANGUAGE_COOKIE_NAME = 'cwc-language';
export const THEME_COOKIE_NAME = 'cwc-theme-mode';
export const COOKIE_CONSENTS_COOKIE_NAME = 'cwc-consents';
export const WOLT_UID_COOKIE_NAME = '__woltUid';
export const WOLT_SESSION_COOKIE_NAME = '__woltAnalyticsId';
export const WOLT_DEVICE_COOKIE_NAME = '__woltDeviceId';
export const WFW_REGISTER_LOGIN_COOKIE_NAME = 'cwc-wfw-register-login';
export const UTM_PARAMS_COOKIE_NAME = 'cwc-utm-params';
